module.exports = __webpack_public_path__ + "media/images/countrysquared/ps-a637f2cf84da1f293ca0e8a1cebf7e62.svg";